// @flow
import * as React from 'react'
import styled from 'styled-components'
import { CheckMark } from '../components/shared/icons'
import CheckIcon from '@components/shared/icons/CheckIcon'

import { P } from '../components/shared/typography'
import { config } from 'react-awesome-styled-grid'

export const ValueProp = (props: { text: string, isSimpleCheck?: boolean }): React.Node => {
  return (
    <Container>
      <CheckContainer isSimpleCheck={!!props.isSimpleCheck}>
        {props.isSimpleCheck ? <CheckIcon /> : <CheckMark />}
      </CheckContainer>
      <Text>{props.text}</Text>
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
`
const CheckContainer = styled.div`
  align-items: center;
  display: flex;
  height: 24px;
  margin: 0 ${(props: { isSimpleCheck: boolean }): number => props.isSimpleCheck ? 0 : 16}px 0 0;
  width: 24px;

  ${(props: any): string => config(props).media.sm`
     margin: 0 ${(props: { isSimpleCheck: boolean }): number => props.isSimpleCheck ? 10 : 16}px 0 0;
  `}

 ${(props: any): string => config(props).media.lg`
    svg {
     transform: scale(1.3);
     margin: 0 0 2px 2px;
    }
  `}
`
const Text = styled(P)`
  font-size: 12px;
  line-height: 18px;
  flex: 1;
  
  ${(props: any): string => config(props).media.sm`
    font-size: 14px;
    line-height: 21px;
  `}
  ${(props: any): string => config(props).media.lg`
    font-size: 16px;
    line-height: 24px;
  `}
`
